// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { PopupForm } from './popup-form';
import { prepareUrl, getComponent } from './common';
import { redirect } from './form-redirect';

/**
 * @class Jsw.ConfirmationPopupManager.PopupForm
 * @extends Jsw.PopupForm
 */
export const ConfirmationPopupManager = {};
ConfirmationPopupManager.PopupForm = Class.create(PopupForm, {
    _sendButtonTitle: '',

    _initConfiguration($super, config) {
        config = Object.extend({
            singleRowButtons: true,
        }, config || {});
        $super(config);

        this._prepareUrl = this._getConfigParam('prepareUrl', '');
        this._handlerUrl = this._getConfigParam('handlerUrl', '');
        this._ids = this._getConfigParam('ids', '');
        this._formListItemsAreaId = `${this._id}-form-list-items`;
        this._formListAreaId = `${this._id}-form-list`;
        this._formBoxAreaId = `${this._id}-form-box`;
        this._sendButtonId = this._getConfigParam('sendButtonId', 'btn-send');
        this._cancelButtonId = this._getConfigParam('cancelButtonId', 'btn-cancel');
        this._formDescriptionId = `${this._id}-form-desc`;
        this._longtask = this._getConfigParam('longtask', false);
        this._autoload = this._getConfigParam('autoload', true);
    },

    render($super) {
        $super();

        this.setBoxType('form-box');
        this._setTitle();

        const formHtml = `<form method="post" action="" enctype="application/x-www-form-urlencoded" id="${this._id}-form">` +
            `<div class="box" id="${this._formBoxAreaId}"></div>` +
            `<div class="list" id="${this._formListAreaId}"></div>` +
            '</form>';

        $(this._contentAreaId).update(
            this._getHeadDescription() +
            formHtml +
            this._getBottomDescription()
        );

        const form = $(`${this._id}-form`);
        form._formSubmit = form.submit;
        form.submit = this._onSubmit.bind(this);
        form.observe('submit', this._onSubmitEvent.bind(this));

        $(this._formBoxAreaId).insert(`<div class="ajax-loading">${this.lmsg('loading')}</div>`);

        this._addButtons();

        if (this._autoload) {
            this._renderPreparePopup();
        }
    },

    reload() {
        $(this._formListAreaId).update('');
        $(this._formBoxAreaId).update(`<div class="ajax-loading">${this.lmsg('loading')}</div>`);
        this._preparePopup();
    },

    _addButtons() {
        this.addRightButton(this.lmsg('buttonOk'), this._onOkClick, true, true, { id: this._sendButtonId });
        this.addRightButton(this.lmsg('buttonCancel'), this._onCancelClick, false, false, { id: this._cancelButtonId });
    },

    _setTitle() {
        this.setTitle(this.lmsg('title'));
    },

    _getHeadDescription() {
        return '';
    },

    _getBottomDescription() {
        return `<p id="${this._formDescriptionId}">${this.lmsg('description')}</p>`;
    },

    _onException(transport, exception) {
        this._addErrorMessage(`Internal error: ${exception}`);
        this.enable();
    },

    _onOkClick(e) {
        this._onSubmit(e);
    },

    _onCancelClick() {
        this.hide();
    },

    _preparePopup() {
        const ids = $H();
        let count = 0;

        this._ids.each(function (id) {
            ids.set(`ids[${count}]`, id);
            count++;
        });

        new Ajax.Request(
            prepareUrl(this._prepareUrl), {
                method: 'post',
                parameters: ids,
                onSuccess: this._onSuccessPreparePopup.bind(this),
                onException: this._onException.bind(this),
            }
        );
    },

    _renderPreparePopup() {
        this._preparePopup();
    },

    _onSubmitEvent(event) {
        this._onSubmit();
        Event.stop(event);
        return false;
    },

    _onSuccessResponse(response) {
        this.hide();
        redirect(response.redirect);
    },

    _onSuccess(transport) {
        this._clearMessages();
        try {
            const response = transport.responseText.evalJSON();
            if ('success' === response.status) {
                this._onSuccessResponse(response);
            } else {
                if (response.redirect) {
                    redirect(response.redirect);
                    return;
                }
                this._addErrorMessage(response.message);
                this.enable();
            }
        } catch (e) {
            this._addErrorMessage(e.message);
            this._addErrorMessage(
                `Internal error: ${transport.responseText}`
            );
            this.enable();
        }
    },

    disable() {
        const sendButtonWrapper = $(this._sendButtonId);
        if (sendButtonWrapper) {
            const sendButton = sendButtonWrapper.down('button');
            sendButton.disabled = true;
            sendButtonWrapper.addClassName('disabled');
            if (!this._sendButtonTitle) {
                this._sendButtonTitle = sendButton.innerHTML;
            }
            sendButton.update(`<span class="wait">${this.lmsg('loading')}</span>`);
        }

        const cancelButtonWrapper = $(this._cancelButtonId);
        if (cancelButtonWrapper) {
            cancelButtonWrapper.down('button').disabled = true;
            cancelButtonWrapper.addClassName('disabled');
        }
    },

    enable() {
        const sendButtonWrapper = $(this._sendButtonId);
        if (sendButtonWrapper) {
            const sendButton = sendButtonWrapper.down('button');
            sendButton.disabled = false;
            sendButton.update(this._sendButtonTitle);
            sendButtonWrapper.removeClassName('disabled');
        }

        const cancelButtonWrapper = $(this._cancelButtonId);
        if (cancelButtonWrapper) {
            cancelButtonWrapper.down('button').disabled = false;
            cancelButtonWrapper.removeClassName('disabled');
        }
    },

    _onSuccessPreparePopup() {
        // should be implemented in child classes
        return true;
    },

    _getLoadingIndicatorItems() {
        return [];
    },

    _addLoadingIndicator(items) {
        // should be implemented in child classes
    },

    _getAdditionalParams(params) {
        // should be implemented in child classes if it necessary
        return params;
    },

    _isValid() {
        return true;
    },

    _onSubmit(e) {
        this._clearMessages();

        if (!this._isValid()) {
            return;
        }

        let params = $H();
        let count = 0;
        this._ids.each(function (id) {
            params.set(`ids[${count}]`, id);
            count++;
        });
        params = this._getAdditionalParams(params);

        this.disable();
        this._addLoadingIndicator(this._getLoadingIndicatorItems());

        if (this._needFlyEffect()) {
            const context = this;
            const beginOffset = e.target.cumulativeOffset();
            getComponent('asyncProgressBarWrapper').fly(beginOffset,
                this._longtask,
                function () {
                    context._sendRequest(params);
                });
        } else {
            this._sendRequest(params);
        }
    },

    _needFlyEffect() {
        return (false !== this._longtask);
    },

    _sendRequest(params) {
        new Ajax.Request(
            this._handlerUrl,
            {
                method: 'post',
                parameters: params,
                onSuccess: this._onSuccess.bind(this),
                onException: this._onException.bind(this),
            }
        );
    },
});



// WEBPACK FOOTER //
// ./jsw/confirmation-popup-manager.js